import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';
import { Question } from 'types/question.types';

import { FeedbackQuestionsFragment } from '../common';

export interface QuestionSortOrder {
  questionId: number;
  sortOrder: number;
}

export interface ReorderEventQuestionnaireQuestionsInput {
  eventId: number;
  questionSortOrders: QuestionSortOrder[];
}

export interface ReorderEventQuestionnaireQuestionsResult {
  reorderEventQuestionnaireQuestions: {
    ok: boolean;
    event: {
      id: number;
      preEventQuestions: Question[];
    };
  };
}

const ReorderEventQuestionnaireQuestionsMutation = gql`
  mutation reorderEventQuestionnaireQuestions($input: ReorderEventQuestionnaireQuestionsInput!) {
    reorderEventQuestionnaireQuestions(input: $input) {
      ok
      event {
        id
        preEventQuestions {
          ...FeedbackQuestionsFragment
        }
      }
    }
  }
  ${FeedbackQuestionsFragment}
`;

export const reorderEventQuestionnaireQuestions = (
  input: ReorderEventQuestionnaireQuestionsInput
): Promise<ReorderEventQuestionnaireQuestionsResult> => {
  return gqlClient.request<ReorderEventQuestionnaireQuestionsResult>(
    ReorderEventQuestionnaireQuestionsMutation,
    {
      input
    }
  );
};
